// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import { Integrations } from "@sentry/tracing";
import {
	ReportingObserver as ReportingObserverIntegration,
	Dedupe as DedupeIntegration,
} from "@sentry/integrations";

const online = ENV_ISONLINE;
const isProd = ENV_ISPROD;
const dsn = "https://55a0be363afb4966b35e9eb255e73652@sentry.lightinthebox.com/7";

console.log("sentry client online =====> ", online);

const integrations = [
	new ReportingObserverIntegration(),
	new Integrations.BrowserTracing({
		beforeNavigate: (context) => {
			return {
				...context,
				name: replacePathname(location.pathname),
			};
		},
	}),
	// 去重：删除某些事件的重复数据
	new DedupeIntegration(),
];

Sentry.init({
	serverName: "OPTIMUS_V2_EZBUY",
	integrations,
	dsn,
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
	// release: SENTRY_RELEASE ? SENTRY_RELEASE.id : NEXT_PUBLIC_COMMIT_SHA,
	tracesSampler: () => {
		return 1;
	},
	environment: online ? "online" : isProd ? "dev" : "test",
	ignoreErrors: [
		"getAttribute",
		// Heavy Ad Intervention
		"Ad was removed",
		"Non-Error promise rejection captured",
	],
	denyUrls: [
		"https://ctrlitb.rightinthebox.com/ctr_tracking.php",
		"https://bat.bing.com/bat.js",
		"https://c.go-mpulse.net",
		"https://s.go-mpulse.net/boomerang/D8XY7-ZTTUT-KNRUR-CTM7D-KLYLX",
		"https://www.google-analytics.com/analytics.js",
	],
	// This option is required for capturing headers and cookies.
	sendDefaultPii: true,
	tracesSampleRate: 1.0,
	normalizeDepth: 10,
});

function replacePathname(pathname = "") {
	if (pathname.match(/\/active\//)) {
		return "/active";
	}
	return pathname;
}
